import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DeleteClient = (props) => {
  const {t} = useTranslation();

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("Delete Client")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p> {t("Are you sure you want to delete your Client? This action cannot be undone.")} </p>
        </Modal.Body>
        <Modal.Footer>
          <button className="button" onClick={props.onHide}> {t("Cancel")} </button>
          <button className="button" variant="" onClick={props.onDelete}> {t("Delete")} </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteClient;
